<template>
  <div class="w-full h-full flex flex-col pb-96p sm:pb-128p">
    <page-hero bg="projects-background" :title="page.title" :subtitle="page.sub_title">
      <template #title>
        From <span class="text-primary1">Idea</span> Into Excellent <span class="text-primary1">Result!</span>
      </template>
    </page-hero>

    <section-layout>
      <template #title>
        Our Projects
      </template>

      <template #subtitle>
        Products we have taken from an idea to a release
      </template>

      <div class="px-0 xl:px-100p grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 justify-items-center max-w-content mx-auto">
      <router-link
        :to="`/project-info/${project.id}`"
        v-for="(project, index) in showedCards"
        :key="project.id"
        data-aos="fade-up"
        :data-aos-delay="(index % 3) * 90"
        class="h-full w-full flex justify-center"
      >
        <projects-item>
          <template #logo>
            <img :src="project.logo" :alt="`${project.brand} logo`" class="w-3/5">
          </template>

          <template #brand>
            {{ project.brand }}
          </template>

          <template #short_description>
            {{ project['short-description'] }}
          </template>
        </projects-item>
      </router-link>
      </div>

      <div v-if="!isShowAllCards" class="flex justify-center mt-16" data-aos="fade-up">
        <custom-button type="secondary" @buttonClick="switchShowedCurds">
          Load more
        </custom-button>
      </div>
    </section-layout>

  </div>
</template>

<script>
export default {
  name: 'Projects',
}
</script>

<script setup>
import ProjectsItem from '@/components/ProjectInfo/ProjectsItem'
import { computed, ref } from 'vue'
import { useContent } from '@/composables/useContent'
import customButton from '@/components/UI_components/CustomButton'
import PageHero from "@/components/PageHero";
import SectionLayout from '@/layouts/SectionLayout'
import projectsData from '@/store/projects.js'

// Названия, описания и логотипы проектов редактируются в админке.
// Галереи и подробные описания пока живут в src/store/projects.js вместе
// с самими изображениями, поэтому локальная запись подхватывается по
// названию проекта.
const slugify = (value) => String(value ?? '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/(^-|-$)/g, '')

const { items: apiProjects } = useContent('project', [])

const projects = computed(() => {
  if (!apiProjects.value.length) return projectsData

  return apiProjects.value.map((item) => {
    const slug = item.slug || slugify(item.name)
    const local = projectsData.find((p) => slugify(p.brand) === slug)

    return {
      ...(local ?? {}),
      id: slug,
      brand: item.name,
      logo: item.file?.url || local?.logo || '',
      'short-description': item.brief || local?.['short-description'] || '',
    }
  })
})

const isShowAllCards = ref(false)

const showedCards = computed(() => {
  if(isShowAllCards.value) {
    return projects.value
  }else{
    return projects.value.slice(0, 3)
  }
})

const switchShowedCurds = () => {
  isShowAllCards.value = true
}

// Заголовок страницы и текст блока «свяжитесь с нами» редактируются в админке
const { items: pageData } = useContent('projectsPage', [])
const page = computed(() => pageData.value[0] ?? {})

</script>
<style>
.bg-projects-background {
  background-image: url('~@/assets/backgrounds/projects-background.png');
}
</style>